import { PeopleQueryBaseDto } from './people-query-base.dto';
import { PeopleEmployeePersonalDetailsDto } from './employee';

export class PeopleHonorificTitleDto {
  id: number;
  honorificTitle: string;

  employeePersonalDetails?: PeopleEmployeePersonalDetailsDto[];
}

export interface PeopleHonorificTitleQueryDto extends PeopleQueryBaseDto {
  honorificTitle?: string;
}
